module.exports = ".select-children {\n  max-height: 300px;\n  overflow: auto;\n}"